var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookinline = function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#fff",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M15.142 18.143v8h3.34v-8h2.49l.474-3.31h-2.964v-2.147c0-.905.414-1.788 1.742-1.788h1.348V8.081s-1.223-.224-2.393-.224c-2.441 0-4.037 1.585-4.037 4.455v2.522H12.43v3.31z"
  })));
};
export default SvgFacebookinline;